import React from 'react';
import HighchartsReact from 'highcharts-react-official';
import Highcharts, { ChartOptions } from 'highcharts';
import { defaultChartOptions, defaultTooltip, defaultXAxisFormat } from 'constants/chart-constants';
import { ChartProps } from 'views/Analytics/AnalyticsMockService/Reporting/Report';
import _ from 'lodash';

const mockServiceReponseTypeChartOptions: ChartOptions = { ...defaultChartOptions, type: 'spline', zoomType: 'x' };

const LinesChart = (chartProps: ChartProps) => {
  const options: Highcharts.Options = {
    chart: mockServiceReponseTypeChartOptions,
    title: {
      text: '',
    },
    xAxis: {
      type: 'datetime',
      min: chartProps.min,
      max: chartProps.max,
      labels: {
        rotation: -45,
      },
      dateTimeLabelFormats: defaultXAxisFormat,
    },
    yAxis: {
      title: {
        text: '',
      },
      labels: {
        formatter: function() {
          return chartProps.yAxisUnitSuffix ? this.value + ' ' + chartProps.yAxisUnitSuffix : this.value;
        },
      } as any,
    },
    tooltip: chartProps.tooltip ? chartProps.tooltip : defaultTooltip,
    credits: {
      enabled: false,
    },
    plotOptions: {
      line: {
        dataLabels: {
          enabled: true,
        },
        enableMouseTracking: false,
      },
      series: {
        lineWidth: 4,
        animation: {
          duration: 0,
        },
      },
    },
    time: {
      useUTC: !_.isNil(chartProps.useUTC) ? chartProps.useUTC : true,
    },
    series: chartProps.chartSeries as any[],
  };

  return <HighchartsReact highcharts={Highcharts} options={options} />;
};

export default LinesChart;
